"use client";

import * as React from "react";

type ContextType = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const CommandPaletteContext = React.createContext<ContextType | null>(null);

export const useCommandPalette = () => {
  const ctx = React.useContext(CommandPaletteContext);
  if (!ctx) throw new Error("Wrap with CommandPaletteProvider");
  return ctx;
};

export const CommandPaletteProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <CommandPaletteContext.Provider value={{ open, setOpen }}>
      {children}
    </CommandPaletteContext.Provider>
  );
};